import { USE_EXTERNAL_API } from '@m/config/env';
import { KeycloakService } from '@m/keycloak-service/KeycloakService';
import GoogleAuth from '@m/utils/GoogleAuth';
import { heapClearEventProperties, heapIdentityReset, heapTrackProperties } from '@m/utils/heap';
import { apiFetch, setAuthToken } from '@m/utils/http';
import { userAnalytics } from '@m/utils/userAnalytics';
import { createEffect, createEvent } from 'effector';

let gAuth: GoogleAuth;

export const getUser = createEffect({
  handler: () => apiFetch('/user'),
});

export const getUserById = createEffect((userId: number) => apiFetch(`/user/${userId}`));

export const setSelectedSiteId = createEvent<{ siteId: number }>();

export const showLoginPrompt = createEvent();

export const hideLoginPrompt = createEvent();

export const requestLoginCode = createEffect({
  handler: ({ phoneNumber }: { phoneNumber: string }) => {
    heapTrackProperties('Login', {
      login_method: 'phone',
    });
    return apiFetch('/specialist/login/send', {
      method: 'POST',
      // @ts-ignore ts-migrate(2322) FIXME: Type '{ phoneNumber: string; }' is not assignable ...
      body: { phoneNumber },
    });
  },
});
export const requestIntakeLoginCode = createEffect({
  handler: ({ phoneNumber }: { phoneNumber: string }) => {
    heapTrackProperties('Login', {
      login_method: 'intake-phone',
    });
    return apiFetch('/intake/login/send', {
      method: 'POST',
      // @ts-ignore ts-migrate(2322) FIXME: Type '{ phoneNumber: string; }' is not assignable ...
      body: { phoneNumber },
    });
  },
});

export const verifyCode = createEffect({
  handler: async ({
    phoneNumber,
    code: secret,
    beginSession, // Stores session in cookie, else receives session token
  }: {
    beginSession: boolean;
    code: string;
    phoneNumber?: string | null;
  }) => {
    const sessionMode = beginSession ? 'cookie' : undefined;
    const response = await apiFetch('/user/verification', {
      params: {
        phoneNumber,
        secret,
        sessionMode: USE_EXTERNAL_API ? 'token' : sessionMode,
      },
    });
    USE_EXTERNAL_API && setAuthToken(response?.data?.token);

    return response;
  },
});

export const login = createEffect({
  handler: async () => {
    if (!gAuth) {
      gAuth = new GoogleAuth();
    }
    const { email, code, provider } = await gAuth.login();
    heapTrackProperties('Login', {
      login_method: 'google',
    });
    const response = await apiFetch('/login', {
      method: 'POST',
      body: {
        login: email,
        code,
        provider,
        sessionMode: USE_EXTERNAL_API ? 'token' : undefined,
      },
    });

    USE_EXTERNAL_API && setAuthToken(response?.data?.token);
    return response;
  },
});

export const loginMicrosoft = createEffect({
  handler: async ({ email, code }: { code: string; email: string }) => {
    heapTrackProperties('Login', {
      login_method: 'microsoft',
    });
    const response = await apiFetch('/login', {
      method: 'POST',
      body: {
        login: email,
        code,
        provider: 'microsoft',
        sessionMode: USE_EXTERNAL_API ? 'token' : undefined,
      },
    });

    USE_EXTERNAL_API && setAuthToken(response?.data?.token);
    return response;
  },
});

export const logout = createEffect({
  handler: async () => {
    heapIdentityReset();
    heapClearEventProperties();

    if (KeycloakService.isLoggedIn()) {
      await KeycloakService.doLogout();
      userAnalytics.unsetUser();
      return { success: true };
    }

    return apiFetch('/logout', { method: 'POST' }).finally(() => {
      userAnalytics.unsetUser();
    });
  },
});
